export enum OnboardingTarget {
  SalesRep = 'sales',
  Consumer = 'consumer',
}
